import { useQuery } from '@tanstack/react-query';
import documentService from '../services/documentService';

export const useDocuments = (status?: string) => {
  return useQuery({
    queryKey: ['documents', status],
    queryFn: () => documentService.listDocuments(0, 50, status),
    refetchInterval: 5000, // Refresh every 5 seconds
  });
};